import React, { Fragment } from 'react';
import  {
    AUtableCaption, 
    AUtableHeader,
    AUtableRow,
    AUtableBody, 
    AUtableHead 
} from '@gov.au/table';
import PropTypes from 'prop-types';

import { RepeatingSummaryRow, RepeatingSummarySubRow } from './RepeatedSummaryRow';


const generateTableHeader = (tableHeader, removeUserCallback) => {
    return (
        <Fragment>
            {
                tableHeader.map((headerRow, index) => {
                    return (
                        <AUtableHeader type="text" key={index} title={headerRow.title} width={headerRow.width}/>
                    )
                })
            }
            {removeUserCallback !== undefined &&
                <AUtableHeader type="text" title="" width="20"/>
            }
        </Fragment>
    )
}

/*
 * RepeatingSummary
 *
 * @param  {string}    name                - name of the object in the row
 * @param  {array}     tableHeader         - table headers 
 * @param  {object}    tableBody           - table rows
 * @param  {function}  editUserCallback    - function for editing object in the row
 * @param  {function}  removeUserCallback  - function for editing object in the row
 * @param  {string}    caption             - title for the table
 */
export const RepeatingSummary = ({ name, tableHeader, tableBody, caption, editUserCallback, removeUserCallback }) => {
    const generateTableBody = () => {
        return (
            Object.keys(tableBody).map((id, index) => {
                return (
                    <RepeatingSummaryRow
                        id={id}
                        name={tableBody[id][name]}
                        key={id + index}
                        tableHeader={tableHeader}
                        tableRowData={tableBody[id].additionalDetails}
                        editUserCallback={editUserCallback}
                        removeUserCallback={removeUserCallback}
                    />
                )   
            })
        )
    }

    return (
        <table className="au-table au-table--striped">
            <AUtableCaption 
                tableCaption={caption} />
            <AUtableHead>
                <AUtableRow>
                    {generateTableHeader(tableHeader, removeUserCallback)}
                </AUtableRow>
            </AUtableHead>
            {tableBody &&
                <AUtableBody>
                    {generateTableBody()}
                </AUtableBody>
            }
        </table>
    )
};

RepeatingSummary.propTypes = {
    name: PropTypes.string.isRequired,
    tableHeader: PropTypes.array.isRequired,
    tableBody: PropTypes.object.isRequired,
    editUserCallback: PropTypes.func,
    removeUserCallback: PropTypes.func,
    caption: PropTypes.string
};

/*
 * MplExclusionRepeatingTable
 *
 * @param  {string}    name                - name of the object in the row
 * @param  {array}     tableHeader         - table headers 
 * @param  {object}    tableBody           - table rows
 * @param  {function}  editUserCallback    - function for editing object in the row
 * @param  {function}  removeUserCallback  - function for editing object in the row
 * @param  {string}    caption             - title for the table
 */

export const MplExclusionRepeatingSummary = ({ name, tableHeader, tableBody, caption, editUserCallback, removeUserCallback }) => {
    const generateTableBody = () => {
        let striped = true
        return (
            Object.keys(tableBody).map((id, index) => {
                striped = !striped
                const subRowCount = tableBody[id].additionalDetails["exclusionCategoriesToBeRemoved"].answer.checkboxes;
                return (
                    Object.values(subRowCount).map((item, answerIndex) => {
                        if (item.check) {
                            if (answerIndex === 0) {
                                const updatedRepeatingQuestion = {
                                    ...tableBody[id].additionalDetails["exclusionCategoriesToBeRemoved"],
                                    type: "text",
                                    answer: {
                                        value: item.text
                                    }
                                }
                                let newTableBody = {
                                    ...tableBody[id].additionalDetails
                                }
                                newTableBody["exclusionCategoriesToBeRemoved"] = updatedRepeatingQuestion;
    
                                const mappedHeaderIndex = tableHeader.findIndex(element => element.key === "mappedElement");
                                let updatedTableHEader = tableHeader
                                updatedTableHEader[mappedHeaderIndex] = {
                                    ...tableHeader[mappedHeaderIndex],
                                    key: "child-" + item.value
                                }
                                
                                return (
                                    <RepeatingSummaryRow
                                        id={id}
                                        name={tableBody[id][name]}
                                        key={id + answerIndex}
                                        tableHeader={tableHeader}
                                        tableRowData={newTableBody}
                                        editUserCallback={editUserCallback}
                                        removeUserCallback={removeUserCallback}
                                        rowSpan={Object.keys(subRowCount).length}
                                        className={striped ? "striped" : ""}
                                    />
                                )   
                            } else {
                                const newTableHeader = [
                                    {title: "Exclusion categories", key: "exclusionCategoriesToBeRemoved", width: "20"},
                                    {title: "Exclusion/limitation codes", key: "childElement", width: "20"},
                                ];
                                const childQuestion = tableBody[id].additionalDetails['child-' + item.value]
                                const newTableBody = [
                                    {
                                        id: "exclusionCategoriesToBeRemoved",
                                        value: item.text
                                    },
                                    {
                                        id: "childElement",
                                        value: childQuestion.answer.checkboxValues,
                                        type: "checkbox"
                                    }
                                ]
                                
                                return (
                                    <RepeatingSummarySubRow
                                        key={id + answerIndex}
                                        tableHeader={newTableHeader}
                                        tableRowData={newTableBody}
                                        className={striped ? "striped subRow" : "subRow"}
                                    />
                                )   
                            }
                        }
                    })
                )
            })
        )
    }

    return (
        <table className="au-table au-table--striped mapped-table student-summary">
            <AUtableCaption 
                tableCaption={caption} />
            <AUtableHead>
                <AUtableRow>
                    {generateTableHeader(tableHeader)}
                </AUtableRow>
            </AUtableHead>
            {tableBody &&
                <AUtableBody>
                    {generateTableBody()}
                </AUtableBody>
            } 
        </table>
    )
};

MplExclusionRepeatingSummary.propTypes = {
    name: PropTypes.string.isRequired,
    tableHeader: PropTypes.array.isRequired,
    tableBody: PropTypes.object.isRequired,
    editUserCallback: PropTypes.func,
    removeUserCallback: PropTypes.func,
    caption: PropTypes.string
};
